import { ReactNode, useEffect } from "react";
import { useLocation as useRouterLocation } from "react-router-dom";
import { WarmHeader } from "./WarmHeader";
import { WarmFooter } from "./WarmFooter";
import { FloatingContactBar } from "../components/FloatingContactBar";
import { useLocation } from "@/contexts/LocationContext";

interface WarmLayoutProps {
  children: ReactNode;
}

export function WarmLayout({ children }: WarmLayoutProps) {
  const { location } = useLocation();
  const { pathname } = useRouterLocation();

  // The homepage hero is a full-bleed video that sits BEHIND the transparent
  // header, so it gets no top offset. Every other page clears the fixed header.
  const isHome = pathname === "/" || pathname === "/seattle" || pathname === "/seattle/";

  useEffect(() => {
    document.documentElement.setAttribute("data-palette", location.paletteId);
  }, [location.paletteId]);

  return (
    <div
      data-theme="warm-home-like"
      className="flex min-h-screen flex-col bg-background overflow-x-hidden"
    >
      <WarmHeader />
      <main className={`flex-1 overflow-x-hidden ${isHome ? "" : "pt-16 md:pt-20"}`}>{children}</main>
      <WarmFooter />
      <FloatingContactBar />
    </div>
  );
}
